import { getMemberRequestsAvailability } from './getMemberRequestsAvailability';
import { postMemberRequestsAvailability } from './postMemberRequestsAvailability';

export const memberRequestsAvailabilityService = {
  get: getMemberRequestsAvailability,
  post: postMemberRequestsAvailability,
};
